import { FirebaseAuthentication } from "@capacitor-firebase/authentication";
import type { JSX } from "react";

export function EmulatorConfig(): JSX.Element {
  if (isEnabled) return <EmulatorStyle />;

  return <></>;
}

function EmulatorStyle(): JSX.Element {
  return (
    <style>{`.firebase-emulator-warning {
      display: none;
    }`}</style>
  );
}

const emulatorHost = import.meta.env.VITE_FIREBASE_AUTH_EMULATOR_HOST;
const emulatorPort = import.meta.env.VITE_FIREBASE_AUTH_EMULATOR_PORT;
const isEnabled = emulatorHost && emulatorPort;

if (isEnabled) {
  // eslint-disable-next-line react-hooks/rules-of-hooks
  FirebaseAuthentication.useEmulator({
    host: emulatorHost,
    port: emulatorPort,
  });
}
